import { Puff } from "react-loader-spinner";

function Spinner() {
  return <Puff color="#00BFFF" height={"30vh"} width={"100%"} />;
}

export default Spinner;
